import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { shiftAdminEndpoints } from '../endpoints';
import { CacheConstants, CacheUtils } from '../../cache';

const getShiftPrevPeriodOverview = (shiftId) =>
  authenticated(insighttAPI).get(shiftAdminEndpoints.getShiftPrevPeriodOverviewAPI(shiftId));

const getShiftCommissions = (shiftId) =>
  authenticated(insighttAPI).get(shiftAdminEndpoints.getShiftCommissionsAPI(shiftId));

const getShiftAlertsFeed = async (id = 0) => {
  const API_KEY = CacheConstants.ACTIVE_SHIFT_ALERTS_FEED(1, 10, id);
  const cache = CacheUtils.getCache(API_KEY);
  if (cache) {
    return Promise.resolve({ data: cache, ok: true, fromCache: true });
  }
  const response = await authenticated(insighttAPI).get(shiftAdminEndpoints.getShiftAlertsFeedAPI(id));
  CacheUtils.setCache(API_KEY, response.data, 10);
  return response;
};

const getShiftAlertsPaginationFeed = async ({ pageNumber, pageLimit, id = 0 }) => {
  const API_KEY = CacheConstants.ACTIVE_SHIFT_ALERTS_FEED(pageNumber, pageLimit, id);
  const cache = CacheUtils.getCache(API_KEY);
  if (cache) {
    return Promise.resolve({ data: cache, ok: true, fromCache: true });
  }
  const response = await authenticated(insighttAPI).get(
    shiftAdminEndpoints.getShiftAlertsFeedPaginationAPI({
      pageNumber,
      pageLimit,
      id,
    }),
  );
  CacheUtils.setCache(API_KEY, response.data, 10);
  return response;
};

const saveAllInfractions = () => authenticated(insighttAPI).post(shiftAdminEndpoints.saveAllInfractionsAPI());

const saveUserInfractionAsRecord = (feedId) =>
  authenticated(insighttAPI).put(shiftAdminEndpoints.saveUserInfractionAsRecordAPI(feedId));

const deleteUserInfraction = (feedId) =>
  authenticated(insighttAPI).delete(shiftAdminEndpoints.deleteUserInfractionAPI(feedId));

const getShiftChecklistFeed = (page = 1, limit = 10, id = 0) =>
  authenticated(insighttAPI).get(shiftAdminEndpoints.getShiftChecklistFeedAPI(page, limit, id));

const markFailedChecklistAsCompleted = (feedId) =>
  authenticated(insighttAPI).delete(shiftAdminEndpoints.markFailedChecklistAsCompletedAPI(feedId));

const getShiftHotListFeed = (branchId = 0) =>
  authenticated(insighttAPI).get(shiftAdminEndpoints.getShiftHotListFeedAPI(branchId));

const getHotListVehicleByVin = (vin) =>
  authenticated(insighttAPI).get(shiftAdminEndpoints.getHotListVehicleByVinAPI(vin));

const addVehicleToManualHotList = (payload) =>
  authenticated(insighttAPI).post(shiftAdminEndpoints.addVehicleToManualHotListAPI(), payload);

const addHotListVehicleComment = (feedId, payload) =>
  authenticated(insighttAPI).post(shiftAdminEndpoints.addHotListVehicleCommentAPI(feedId), payload);

const updateHotListVehicleComment = (feedId, commentId, payload) =>
  authenticated(insighttAPI).put(shiftAdminEndpoints.updateHotListVehicleCommentAPI(feedId, commentId), payload);

const deleteHotListVehicleComment = (feedId, commentId) =>
  authenticated(insighttAPI).delete(shiftAdminEndpoints.deleteHotListVehicleCommentAPI(feedId, commentId));

const archiveManualHotList = (feedId) =>
  authenticated(insighttAPI).delete(shiftAdminEndpoints.archiveManualHotListAPI(feedId));

export const shiftAdminService = {
  getShiftPrevPeriodOverview,
  getShiftCommissions,
  getShiftAlertsFeed,
  getShiftAlertsPaginationFeed,
  saveAllInfractions,
  saveUserInfractionAsRecord,
  deleteUserInfraction,
  getShiftChecklistFeed,
  markFailedChecklistAsCompleted,
  getShiftHotListFeed,
  getHotListVehicleByVin,
  addVehicleToManualHotList,
  addHotListVehicleComment,
  updateHotListVehicleComment,
  deleteHotListVehicleComment,
  archiveManualHotList,
};
